import React from 'react';
import { Link } from 'gatsby';
import * as styles from './button.module.css';

const Button = ({ to, children, className='', variant='primary', onClick = ()=>{}, buttonProps = {} }) => {
  const ButtonComponent = to ? Link : 'button';
  const toProps = to ? { to } : {};

  return (
    <ButtonComponent data-variant={variant} {...toProps} {...buttonProps} className={`${styles.button} ${className}`} onClick={onClick}>
      {children}
    </ButtonComponent>
  );
};

export default Button;
